import { render, staticRenderFns } from "./AIServiceVersion.vue?vue&type=template&id=1c10aab5&scoped=true"
import script from "./AIServiceVersion.vue?vue&type=script&lang=js"
export * from "./AIServiceVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10aab5",
  null
  
)

export default component.exports